import { render, staticRenderFns } from "./mineDatasixth.vue?vue&type=template&id=2b39f73c&scoped=true"
import script from "./mineDatasixth.vue?vue&type=script&lang=js"
export * from "./mineDatasixth.vue?vue&type=script&lang=js"
import style0 from "./mineDatasixth.vue?vue&type=style&index=0&id=2b39f73c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b39f73c",
  null
  
)

export default component.exports